/* eslint-disable eqeqeq */
import { Sticky, StickyContainer } from "react-sticky";
import { BasePage } from "../../../../framework/pages/BasePage";
import { Tabs } from "antd";
import { DetalleMuestreoModal } from "../../tabs/DetalleMuestreoModal";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { DATE_FORMAT, PAGE_MODE } from "../../../../constants/constants";
import ConfigurarPuntosSection from "../../tabs/ConfigurarPuntosSection";
import ProcedenciaMuestraModal from "../../tabs/ProcedenciaMuestraModal";
import EquiposUtilizadosModal from "../../tabs/EquiposUtilizadosModal";
import OtrosDatosModal from "../../tabs/OtrosDatosModal";
import DatosServisiosModal from "../../tabs/DatosServisiosModal";
import { ModalContext } from "../../../../provider/ModalProvider";
import { BUTTON_DEFAULT } from "../../../../framework/bar-button/BarButtonFw";
import { AgregarEstacionModal } from "../../../servicios-ejecutados/tabs/PlanificacionSejecutados/modals/AgregarEstacionModal";
import { EditarEstacionModal } from "../../../servicios-ejecutados/tabs/PlanificacionSejecutados/modals/EditarEstacionModal";
import { MessageUtil } from "../../../../util/MessageUtil";
import { LoadUtil } from "../../../../framework/util/LoadUtil";
import { RequestUtil } from "../../../../util/RequestUtil";
import { EnvConstants } from "../../../../EnvConstants";

class CadenaEmisionEpa10Page extends BasePage {
  static contextType = ModalContext;

  constructor(props) {
    super(props);
    this.state = {
      id_doc: null,
      keyPanel: "1",
    };
    this.cambiarTabPanel = this.cambiarTabPanel.bind(this);
  }

  cambiarTabPanel(tab, id_doc) {
    this.setState({
      id_doc: id_doc,
      keyPanel: tab,
      keyPrincipal: tab,
    });
  }

  renderPage(pageApi, keyPanel) {
    const getgrid_detalle_muestreo = () =>
      pageApi.getComponent("gridDetalleMuestreo");
    const getform_detalle_muestreo = () =>
      pageApi.getComponent("formDetalleMuestreo");
    const { TabPane } = Tabs;

    const fnUpdateItem = (data) => {
      this.context.hideModal();
      getform_detalle_muestreo().setFieldData("id_estacion", data.id_estacion);
      getform_detalle_muestreo().setFieldData(
        "desc_estacion",
        data.DESCRIPCION,
      );
      getform_detalle_muestreo().setFieldData(
        "geo_estacion",
        `E: ${data?.COORDF || "0"}, - ,N:  ${data?.COORDN || "0"}`,
      );
      getform_detalle_muestreo().setFieldData("alt_estacion", data.ALTITUD);
      getform_detalle_muestreo().setFieldData("zona_estacion", data.ZONA);
    };

    const ConfigEstacionModal = (data, esNuevo = true, id_estacion = 0) => {
      const { showModal } = this.context;
      let obj = {};

      obj = {
        fnUpdateItem,
        data: {
          ...data,
          id_tipo_matriz: pageApi.name?.id_tipo_matriz,
          id_empresa: pageApi.name?.id_empresa,
          id_estacion: id_estacion,
        },
      };

      showModal({
        title: esNuevo ? "Agregar Estación" : "Editar Estación",
        width: 350,
        maskClosable: true,
        closable: false,
        background: "white",
        component: esNuevo ? (
          <AgregarEstacionModal name={obj} getParentApi={pageApi.getApi} />
        ) : (
          <EditarEstacionModal name={obj} getParentApi={pageApi.getApi} />
        ),
      });
    };

    const fnCalcPromedio = () => {
      const items = getgrid_detalle_muestreo().getData();

      items.forEach((el) => {
        const cantDecimal = parseInt(el.cantidad_decimales || 0);
        if (el.arr_concentracion_ugm3) {
          const resultado = items.reduce(
            (acc, item) => {
              if (
                el.arr_concentracion_ugm3
                  .split(",")
                  .includes(item.id_sub_parametro?.toString()) &&
                el.muestra == item.muestra
              ) {
                acc.suma += parseFloat(item.concentracion_ugm3);
                acc.contador += 1;
              }
              return acc;
            },
            { suma: 0, contador: 0 },
          );

          el.concentracion_ugm3 =
            resultado.contador > 0
              ? (resultado.suma / resultado.contador).toFixed(cantDecimal)
              : 0;
        }

        if (el.arr_concentracion_mgm3) {
          const resultado = items.reduce(
            (acc, item) => {
              if (
                el.arr_concentracion_mgm3
                  .split(",")
                  .includes(item.id_sub_parametro?.toString()) &&
                el.muestra == item.muestra
              ) {
                acc.suma += parseFloat(item.concentracion_mgm3);
                acc.contador += 1;
              }
              return acc;
            },
            { suma: 0, contador: 0 },
          );

          el.concentracion_mgm3 =
            resultado.contador > 0
              ? (resultado.suma / resultado.contador).toFixed(cantDecimal)
              : 0;
        }

        getgrid_detalle_muestreo().updateItem(el);
      });
      getgrid_detalle_muestreo().refresh();
    };

    const gridBarHeaderButtonConfigPromedio = {
      fields: [
        {
          ...BUTTON_DEFAULT.SAVE,
          label: `Recalcular Promedio`,
          onClick: fnCalcPromedio,
        },
      ],
    };

    const fnCalcSubparam = (items = []) => {
      items.forEach((el) => {
        const cantDecimal = parseInt(el.cantidad_decimales || 0);
        if (el.operacion) {
          const form = getform_detalle_muestreo().getData();
          const variables = el.variables.split(",");

          variables.forEach((item) => {
            const diametro = form[item];
            const operacion = el.operacion.split(" | ").join("");
            // eslint-disable-next-line no-eval
            const resultado = eval(operacion.replace(item, diametro));
            el.distancia = resultado?.toFixed(cantDecimal);
          });

          const ppm = el.concentracion_ppm;
          const mmhg = form.p_campo_mmhg;
          const campoc = form.t_campo_c;

          const resultado_ugm3 =
            ((ppm * (28 / 24.459) * (298 * mmhg)) / ((273 + campoc) * 760)) *
            1000;
          const resultado_mgm3 = resultado_ugm3 / 1000;
          el.concentracion_ugm3 = resultado_ugm3?.toFixed(cantDecimal);
          el.concentracion_mgm3 = resultado_mgm3?.toFixed(cantDecimal);
        }

        if (el.arr_concentracion_ugm3) {
          const resultado = items.reduce(
            (acc, item) => {
              if (
                el.arr_concentracion_ugm3
                  .split(",")
                  .includes(item.id_sub_parametro?.toString()) &&
                el.muestra == item.muestra
              ) {
                acc.suma += parseFloat(item.concentracion_ugm3);
                acc.contador += 1;
              }
              return acc;
            },
            { suma: 0, contador: 0 },
          );

          el.concentracion_ugm3 =
            resultado.contador > 0
              ? (resultado.suma / resultado.contador).toFixed(cantDecimal)
              : 0;
        }

        if (el.arr_concentracion_mgm3) {
          const resultado = items.reduce(
            (acc, item) => {
              if (
                el.arr_concentracion_mgm3
                  .split(",")
                  .includes(item.id_sub_parametro?.toString()) &&
                el.muestra == item.muestra
              ) {
                acc.suma += parseFloat(item.concentracion_mgm3);
                acc.contador += 1;
              }
              return acc;
            },
            { suma: 0, contador: 0 },
          );

          el.concentracion_mgm3 =
            resultado.contador > 0
              ? (resultado.suma / resultado.contador).toFixed(cantDecimal)
              : 0;
        }

        getgrid_detalle_muestreo().updateItem(el);
      });
      getgrid_detalle_muestreo().refresh();
    };

    const formDetalleMuestreo = (pageApi) => {
      let id_estacion_previo = 0;

      return {
        title: "Estación Muestra",
        layout: "vertical",
        autoLoad: true,
        load: {
          queryId: 954,
          params: { id_cadena: pageApi.getParamId() },
          hideMessage: true,
          hideMessageError: true,
        },
        save: {
          queryId: 953,
          params: {
            id_cadena: pageApi.getParamId(),
          },
          fnOk: () => {
            getform_detalle_muestreo().load();
            getgrid_detalle_muestreo().load();
          },
          hideMessage: true,
          hideMessageError: true,
        },
        fields: [
          {
            type: "select",
            name: "id_estacion",
            label: "Estación",
            search: true,
            column: 4,
            // labelName: 'estaciondes', label: 'Estación',
            load: {
              queryId: 846,
              params: () => {
                return { 
                  id_empresa: pageApi.name?.id_empresa,
                  id_tipo_matriz: pageApi.name?.id_tipo_matriz,
                };
              },
            },
            onChange: async (value, values, formApi) => {
              if (value == 0) {
                ConfigEstacionModal(formApi.getData(), true);
                formApi.setFieldData("id_estacion", null);
                formApi.setFieldData("descripcion", null);
                formApi.setFieldData("COORDF", null);
                formApi.setFieldData("COORDN", null);
                id_estacion_previo = 0;
              } else if (value == -1) {
                const estaciones = formApi?.getFieldApi("id_estacion").dataList;
                const estacionPrevio = estaciones.find(
                  (el) => el?.id_estacion === id_estacion_previo,
                );
                let id_estacion = estacionPrevio?.id_estacion;

                if (!id_estacion) {
                  formApi.setFieldData("id_estacion", null);
                  formApi.setFieldData("desc_estacion", null);
                  formApi.setFieldData("geo_estacion", null);
                  formApi.setFieldData("alt_estacion", null);
                  formApi.setFieldData("zona_estacion", null);
                  return MessageUtil(
                    "warning",
                    "Advertencia",
                    "Debe seleccionar primero una estaciòn para poder editar.",
                  );
                }

                formApi.setFieldData("id_estacion", estacionPrevio.id_estacion);
                ConfigEstacionModal(
                  { ...estacionPrevio, id_estacion },
                  false,
                  id_estacion,
                );
                id_estacion_previo = id_estacion;
              } else {
                const id_estacion = value;

                const reqParams = LoadUtil.getReqParams({
                  queryId: 138,
                  params: {
                    ID_ESTACION: id_estacion,
                  },
                });

                const data = await RequestUtil.postData(
                  EnvConstants.GET_URL_READ(),
                  reqParams,
                )
                  .then((resp) => resp.dataObject)
                  .catch(() => []);

                let descripcion = data?.DESCRIPCION;
                let georeferencia = `E: ${data?.COORDF || "0"}, - ,N:  ${data?.COORDN || "0"}`;
                let altitud = data?.ALTITUD;
                let zona = data?.ZONA;

                formApi.setFieldData("id_estacion", value);
                formApi.setFieldData("desc_estacion", descripcion);
                formApi.setFieldData("geo_estacion", georeferencia);
                formApi.setFieldData("alt_estacion", altitud);
                formApi.setFieldData("zona_estacion", zona);
                id_estacion_previo = value;
              }
            },
          },
          {
            name: "desc_estacion",
            label: "Descripción",
            column: 4,
            readOnly: true,
          },
          {
            name: "geo_estacion",
            label: "Georeferencia",
            column: 4,
            readOnly: true,
          },
          { name: "alt_estacion", label: "Altitud", column: 4, readOnly: true },
          { name: "zona_estacion", label: "Zona", column: 4, readOnly: true },
          {
            name: "t_campo_c",
            label: "T° Campo (°C)",
            column: 4,
            editable: true,
            type: "number",
            onChange: () =>
              fnCalcSubparam(getgrid_detalle_muestreo().getData()),
          },
          {
            name: "p_campo_mmhg",
            label: "P Campo (mmHg)",
            column: 4,
            editable: true,
            type: "number",
            onChange: () =>
              fnCalcSubparam(getgrid_detalle_muestreo().getData()),
          },
          {
            name: "diametro",
            label: "Diametro (m)",
            column: 4,
            editable: true,
            type: "number",
            onChange: () =>
              fnCalcSubparam(getgrid_detalle_muestreo().getData()),
          },
          {
            type: "select",
            name: "um_id",
            label: "Unidad de Medida",
            labelName: "desUM",
            column: 4,
            load: { queryId: 583 },
            search: true,
            readOnly: false,
            onChange: (value, values, row, evt) => {
              getgrid_detalle_muestreo()
                .getData()
                .forEach((data) => {
                  data.um_id = value;
                  getgrid_detalle_muestreo().updateItem(data);
                });
              getgrid_detalle_muestreo().refresh();
            },
          },
        ],
      };
    };

    const gridDetalleMuestreo = (pageApi) => ({
      title: "Detalles de Muestreo",
      showIndex: true,
      autoLoad: true,
      barHeader: gridBarHeaderButtonConfigPromedio,
      pagination: {
        server: false,
        showSizeChanger: true,
      },
      rowId: "id_parametro",
      load: {
        validation: () => pageApi.getParamId() != null,
        queryId: 952,
        params: (resp) => {
          return {
            ID_CADENA: pageApi.getParamId(),
          };
        },
        fnOk: (resp) => {
          const items = resp.dataList;
          fnCalcSubparam(items);
        },
        hideMessageError: true,
      },
      save: {
        queryId: 955,
        hideMessage: true,
        hideMessageError: true,
        params: (resp) => {
          return {
            ID_CADENA: pageApi.getParamId(),
          };
        },
      },
      fields: [
        { name: "muestra", label: "Cod. Muestra" },
        { name: "estacion", label: "Estación" },
        { name: "descripcion_estacion", label: "Descripción" },
        { name: "georeferencia", label: "Ubicación Geográfica" },
        { name: "metodo", label: "Metodo" },
        { name: "subparametro", label: "Subparametro" },
        {
          type: "date",
          name: "fecha_inicial",
          label: "Fecha Inicio",
          editable: true,
          format: "DD/MM/YYYY",
          inputFormat: DATE_FORMAT.YYYYMMDD,
        },
        {
          type: "date",
          name: "hora_inicial",
          label: "Hora Inicio",
          editable: true,
          format: DATE_FORMAT.HHmm,
          inputFormat: DATE_FORMAT.HHmm,
        },
        {
          type: "date",
          name: "fecha_fin",
          label: "Fecha Fin",
          editable: true,
          format: "DD/MM/YYYY",
          inputFormat: DATE_FORMAT.YYYYMMDD,
        },
        {
          type: "date",
          name: "hora_fin",
          label: "Hora Fin",
          editable: true,
          format: DATE_FORMAT.HHmm,
          inputFormat: DATE_FORMAT.HHmm,
        },
        // { name: 'desUM', label:'Unidad de Medida', load: { queryId: 583 }, },
        {
          type: "number",
          name: "distancia",
          label: "Distancia",
          editable: false,
        },
        {
          type: "number",
          name: "concentracion_ppm",
          label: "Conc. ppm",
          editable: true,
          onChange: (value, values, formApi) => {
            const form = getform_detalle_muestreo().getData();

            const mmhg = form.p_campo_mmhg;
            const campoc = form.t_campo_c;
            const cantDecimal = parseInt(
              formApi.getData().cantidad_decimales || 0,
            );

            const resultado_ugm3 =
              ((parseFloat(value) * (28 / 24.459) * (298 * mmhg)) /
                ((273 + campoc) * 760)) *
              1000;
            const resultado_mgm3 = resultado_ugm3 / 1000;
            const itemUpdate = formApi.getData();
            delete itemUpdate.concentracion_ppm;
            formApi.setData({
              ...itemUpdate,
              concentracion_ugm3: resultado_ugm3?.toFixed(cantDecimal),
              concentracion_mgm3: resultado_mgm3?.toFixed(cantDecimal),
            });
            formApi?.setFieldData("concentracion_ppm", value);
            getgrid_detalle_muestreo().refresh();
          },
        },
        {
          type: "number",
          name: "concentracion_ugm3",
          label: "Conc. ug/m3",
          editable: false,
        },
        {
          type: "number",
          name: "concentracion_mgm3",
          label: "Conc. mg/m3",
          editable: false,
        },
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    });

    const renderTabBar = (props, DefaultTabBar) => (
      <Sticky bottomOffset={80}>
        {({ style }) => (
          <DefaultTabBar
            {...props}
            className="site-custom-tab-bar"
            style={style}
          />
        )}
      </Sticky>
    );

    const gridsConfigDetalleMuestreo = [
      {
        name: "formDetalleMuestreo",
        config: formDetalleMuestreo(pageApi),
        type: "form",
      },
      {
        name: "gridDetalleMuestreo",
        config: gridDetalleMuestreo(pageApi),
        type: "grid",
      },
    ];

    return (
      <StickyContainer>
        <Tabs
          destroyInactiveTabPane={true}
          activeKey={this.state.keyPanel}
          renderTabBar={renderTabBar}
          onChange={(key) => this.setState({ keyPanel: key })}
        >
          <TabPane tab="Configurar Puntos" key="1">
            <ConfigurarPuntosSection
              api={pageApi}
              cambiarTabPanel={this.cambiarTabPanel}
              history={this.props.history}
            />
          </TabPane>

          <TabPane
            tab="Datos del Servicio"
            key="2"
            disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}
          >
            <DatosServisiosModal
              api={pageApi}
              cambiarTabPanel={this.cambiarTabPanel}
              history={this.props.history}
            />
          </TabPane>

          <TabPane
            tab="Procedencia de la muestra"
            key="3"
            disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}
          >
            <ProcedenciaMuestraModal
              api={pageApi}
              cambiarTabPanel={this.cambiarTabPanel}
              history={this.props.history}
            />
          </TabPane>

          <TabPane
            tab="Detalle del muestreo"
            key="4"
            disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}
          >
            <DetalleMuestreoModal
              api={pageApi}
              data={{ ...pageApi.name }}
              cambiarTabPanel={this.cambiarTabPanel}
              history={this.props.history}
              gridsConfig={gridsConfigDetalleMuestreo}
            />
          </TabPane>

          <TabPane
            tab="Equipos Utilizados"
            key="5"
            disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}
          >
            <EquiposUtilizadosModal
              api={pageApi}
              cambiarTabPanel={this.cambiarTabPanel}
              history={this.props.history}
            />
          </TabPane>

          <TabPane
            tab="Otros Datos"
            key="6"
            disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}
          >
            <OtrosDatosModal
              api={pageApi}
              cambiarTabPanel={this.cambiarTabPanel}
              history={this.props.history}
            />
          </TabPane>
        </Tabs>
      </StickyContainer>
    );
  }
}

export default withRouter(CadenaEmisionEpa10Page);
